import { createStore, applyMiddleware, compose } from 'redux';
import createDebounce from 'redux-debounced';
import thunk from 'redux-thunk';
import rootReducer from '../reducers/rootReducer';
import { useDispatch } from 'react-redux';

const middlewares = [thunk, createDebounce()];

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, {}, composeEnhancers(applyMiddleware(...middlewares)));

export type AppDispatch = any;
export const useAppDispatch: () => AppDispatch = useDispatch;

export { store };
